
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.216.5A5.222 5.222 0 000 5.716v1.305a2.873 2.873 0 001.67 2.604c.487.227.723.787.544 1.294-.337.95-.475 1.13-.224 1.408.099.11.24.173.387.173h1.014a.26.26 0 00.26-.263v-1.043a.522.522 0 111.044 0v1.043c0 .144.117.26.26.26h.522a.26.26 0 00.261-.26v-1.043a.522.522 0 111.043 0v1.043c0 .144.117.26.261.26h1.016a.522.522 0 00.386-.171c.252-.277.115-.454-.223-1.409a1.043 1.043 0 01.543-1.292 2.872 2.872 0 001.669-2.604V5.716A5.22 5.22 0 005.216.5zM2.87 7.806a1.304 1.304 0 110-2.608 1.304 1.304 0 010 2.608zm2.96 1.442a.26.26 0 01-.221.123h-.783a.26.26 0 01-.233-.377l.391-.782a.271.271 0 01.467 0l.39.782a.26.26 0 01-.01.254zm1.735-1.442a1.304 1.304 0 110-2.608 1.304 1.304 0 010 2.608z"}})])
          )
        }
      }
    